var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { State } from 'types/api_request';
import { investLand } from 'services/clients/api/project';
import styles from '../CallBack.module.css';
import { logError } from 'utils/logs';
export default function CallBackInvestment(_a) {
    var _this = this;
    var onNext = _a.onNext, email = _a.email, source = _a.source, project = _a.project, amount = _a.amount, setAmount = _a.setAmount;
    var _b = useState(State.IDLE), state = _b[0], setState = _b[1];
    var t = useTranslation().t;
    var onSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    setState(State.LOADING);
                    return [4 /*yield*/, investLand({ amount: amount, email: email, source: source, step: 2, ayomi_id: project.id })];
                case 1:
                    _a.sent();
                    setState(State.SUCCESS);
                    return [4 /*yield*/, onNext()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    logError(err_1);
                    setState(State.ERROR);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx("h2", { children: t("callback.form.title") }), _jsx("p", { className: styles.description, children: t("callback.form.description") }), (state === State.ERROR) && (_jsxs("p", { className: "error-message", children: [_jsx(FontAwesomeIcon, { icon: "circle-exclamation" }), t("error.request")] })), _jsx("form", { children: _jsxs("label", { children: [t("form.amount.title"), _jsxs("select", { value: amount, onChange: function (e) { return setAmount(Number(e.target.value)); }, children: [_jsxs("option", { value: "0", children: [" ", t("form.amount.0"), " "] }), _jsxs("option", { value: "15", children: [" ", t("form.amount.15"), " "] }), _jsxs("option", { value: "50", children: [" ", t("form.amount.50"), " "] }), _jsxs("option", { value: "100", children: [" ", t("form.amount.100")] })] })] }) }), _jsxs("button", { type: "button", "data-transaction-name": "CallBackInvestment", onClick: onSubmit, className: styles.button, disabled: state === State.LOADING, children: [(state === State.LOADING)
                        && (_jsx("span", { className: "spinner" })), state !== State.LOADING
                        && (_jsxs(_Fragment, { children: [t("callback.form.submit"), _jsx(FontAwesomeIcon, { icon: "arrow-right", className: styles.arrow })] }))] })] }));
}
